import { render, staticRenderFns } from "./SidebarMenuIcon.vue?vue&type=template&id=2069d1ee&"
import script from "./SidebarMenuIcon.vue?vue&type=script&lang=js&"
export * from "./SidebarMenuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports